<template lang="html">

    <div class="cover-popup row-center" v-if="datosEmpresa || datosContacto">
      <div class="popup">

  
        <h2 class="title-pop">¡Atención!</h2>

        <p v-if="datosContacto">Faltan datos obligatorios en tu perfil, por favor accede para completarlos.</p>
        <p v-else>Faltan datos obligatorios en el perfil de tu empresa, por favor accede para completarlos.</p>
  
        <div class="contenedor-botones">
  
          <router-link v-if="datosContacto" to="/mi-perfil" class="btn -solid-primary">Ir a mi Perfil</router-link>
          <router-link v-else :to="$t('enlaces.mi_empresa')" class="btn -solid-primary">Ir a Mi empresa</router-link>
  
        </div>
  
      </div>
    </div>
  
  </template>
  
  <script lang="js">
    
      import {mapGetters,mapActions} from 'vuex';
    
      export default  {
        name: 'popup-faltan-datos-empresa',
        mounted(){
            if(this.datosContacto){
              this.checkFaltanDatosContacto();
            }

            if(this.datosEmpresa){
                this.checkFaltanDatosEmpresa();
            }
        },
        computed : {
          ...mapGetters({
            brand:'getBrand',
            style : 'getStyles',
            datosEmpresa : 'getFaltanDatosAlaEmpresa',
            datosContacto : 'getFaltanDatosAlContacto'
          })
        },
        methods : {
          ...mapActions(['checkFaltanDatosContacto','checkFaltanDatosEmpresa']),
        }
      }
    </script>
  <style scoped lang="scss">
  
    
    
    </style>


// WEBPACK FOOTER //
// src/components/parts/popup-faltan-datos-empresa.vue